/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Hook source usage statistics
 */
export type HookSourceUsage = {
  /**
   * Total hook events for this source
   */
  eventCount: number;
  /**
   * Hook source (from attributes.gram.hook.source)
   */
  source: string;
};

/** @internal */
export const HookSourceUsage$inboundSchema: z.ZodMiniType<
  HookSourceUsage,
  unknown
> = z.pipe(
  z.object({
    event_count: z.int(),
    source: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "event_count": "eventCount",
    });
  }),
);

export function hookSourceUsageFromJSON(
  jsonString: string,
): SafeParseResult<HookSourceUsage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => HookSourceUsage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'HookSourceUsage' from JSON`,
  );
}
